import { Component, Input } from '@angular/core';
import { TreeNode } from 'primeng/api';

@Component({
  selector: 'app-comments',
  templateUrl: './comments.component.html',
  styleUrls: ['./comments.component.scss']
})
export class CommentsComponent {
  @Input() comments: TreeNode[] = [];
}
